export default __webpack_public_path__ + "static/conexum-color-8309eb6691bf3c80173307f32f318365.svg";